<template>
  <v-container fluid>
    <v-card class="card-rounded">
      <v-form lazy-validation>
        <v-card-title>
          <span class="headline">Conciliação</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-data-table
                :headers="headers"
                :items="boletos"
                :items-per-page="10"
                :loading="loading"
                :no-data-text="
                  loading ? 'Carregando' : 'Nenhum Registro para mostrar'
                "
                class="elevation-1"
              >
                <template v-slot:[`item.data`]="{ item }">
                  <span>{{ formatDate(item.data) }}</span>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <span>{{ formatStatus(item.status) }}</span>
                </template>
                <template v-slot:[`item.edit`]="{ item }">
                  <v-icon small @click="onEditBoleto(item)">edit</v-icon>
                </template>
              </v-data-table>
            </v-row>
          </v-container>
        </v-card-text>

        <v-dialog v-model="editBoleto" persistent max-width="600">
          <v-card>
            <v-card-title>
              Boleto
            </v-card-title>
            <v-card-text>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <span>Usuário: {{ boleto.nome }}</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <span>Email: {{ boleto.email }}</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <span>Cpf: {{ boleto.cpf }}</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <span>Telefone: {{ boleto.telefone }}</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content class="pt-0">
                  <v-list-item-title>
                    <v-text-field
                      class="mt-4"
                      style="max-width: 300px;"
                      hide-details
                      outlined
                      label="Número Boleto - Banco"
                      v-model="boleto.numero"
                    ></v-text-field>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content class="pt-0">
                  <v-list-item-title>
                    <v-select
                      style="max-width: 300px;"
                      class="mt-4"
                      outlined
                      :items="boletoStatus"
                      label="Status"
                      item-text="label"
                      item-value="value"
                      v-model="boleto.status"
                    ></v-select>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn ma-2 text small color="grey" @click="onCancelEditBoleto()"
                >Cancelar</v-btn
              >
              <v-btn
                ma-2
                text
                small
                color="primary"
                :loading="loading"
                @click="onSaveBoleto()"
                >Confirmar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import util from "@/service/util-service";

export default {
  data() {
    return {
      editBoleto: false,
      boleto: {},
      boletoStatus: [
        { value: "S", label: "Solicitado" },
        { value: "E", label: "Enviado" },
        { value: "P", label: "Pago" },
      ],
      headers: [
        { text: "Editar", align: "right", sortable: false, value: "edit" },
        {
          text: "Numero/Banco",
          align: "left",
          sortable: true,
          value: "numero",
        },
        {
          text: "Origem",
          align: "left",
          sortable: true,
          value: "origem",
        },
        {
          text: "Status",
          align: "left",
          sortable: true,
          value: "status",
        },
        {
          text: "Usuário",
          align: "left",
          sortable: true,
          value: "nome",
        },
        {
          text: "Email",
          align: "left",
          sortable: true,
          value: "email",
        },
        {
          text: "CPF",
          align: "left",
          sortable: true,
          value: "cpf",
        },
        {
          text: "Telefone",
          align: "left",
          sortable: true,
          value: "telefone",
        },
        {
          text: "Documento",
          align: "left",
          sortable: true,
          value: "documento",
        },
        {
          text: "Data",
          align: "left",
          sortable: true,
          value: "data",
        },
        {
          text: "Valor",
          align: "left",
          sortable: true,
          value: "valor",
        },
      ],
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      boletos: "boletos",
    }),
  },
  created() {
    this.getDadosBoletos();
  },

  methods: {
    onEditBoleto(item) {
      this.editBoleto = true;
      this.boleto = { ...item };
    },
    onCancelEditBoleto() {
      this.boleto = {};
      this.editBoleto = false;
    },
    onSaveBoleto() {
      this.loading = true;
      this.$store
        .dispatch("atualizarBoleto", this.boleto)
        .then((value) => {
          if (value.type == "ok") {
            this.$store.dispatch("setNotification", {
              type: "info",
              text: value.msg,
            });
            this.getDadosBoletos();
            this.boleto = {};
            this.editBoleto = false;
          } else {
            this.$store.dispatch("setNotification", {
              type: "error",
              text: "Ouve um erro ao conciliar os boletos",
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Ouve um erro ao atualizar o boleto",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    conciliarBoletos() {
      this.loading = true;
      this.$store
        .dispatch("conciliarBoletos")
        .then((value) => {
          this.getDadosBoletos();
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Ouve um erro ao conciliar os boletos",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDadosBoletos() {
      this.loading = true;
      this.$store
        .dispatch("getBoletosEmAberto")
        .then((value) => {})
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Ouve um erro ao consultar os boletos",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
    formatStatus(status) {
      if (status == "S") {
        return "Solicitado";
      } else if (status == "E") {
        return "Enviado";
      } else if (status == "P") {
        return "Pago";
      }
      return "";
    },
  },
};
</script>
